import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc";
import logo from "../assets/img/logo.png";
import { Link } from "react-router-dom";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PageCount from "./utils/PageCount";



// ------------------------------------------------------
// ⭐ GET IP + DEVICE + LOCATION FUNCTION
// ------------------------------------------------------
const getClientInfo = async () => {
  try {
    const res = await axios.get("https://ipapi.co/json/");

    const deviceOS = navigator.platform;
    const deviceBrowser = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(navigator.userAgent)
      ? "Mobile"
      : "Desktop";

    const clientInfo = {
      ip_address: res.data.ip || "",
      device_os: deviceOS,
      device_browser: deviceBrowser,
      device_type: deviceType,
      location_city:     res.data.city || "",
      location_state:    res.data.region || "",
      location_country:  res.data.country_name || "",
      latitude:          res.data.latitude || "",
      longitude:         res.data.longitude || "",
    };

    console.log("📌 Client Info Collected:", clientInfo);
    return clientInfo;
  } catch (err) {
    console.error("❌ IP API Error:", err);
    return {};
  }
};

function LoginModal({ show, onClose, onLoginSuccess }) {
  const [activeTab, setActiveTab] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

const navigate = useNavigate();

  const [loadingLogin, setLoadingLogin] = useState(false);
const [loadingRegister, setLoadingRegister] = useState(false);


  // ------------------------------------------------------
  // ⭐ LOGIN FUNCTION WITH IP + DEVICE + LOCATION
  // ------------------------------------------------------
const handleLogin = async (e) => {
  e.preventDefault();

  if (!email || !password) {
    Swal.fire({
      icon: "warning",
      title: "Please enter email and password.",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2500,
    });
    return;
  }

  setLoadingLogin(true);

  try {
    const clientInfo = await getClientInfo();

    const loginData = {
      email,
      password,
      ...clientInfo,
    };

    const response = await axios.post(`${baseurl}loginUser`, loginData);
    const data = response.data;

    // ⭐ STORE TOKEN WITH 100 DAYS EXPIRY
    if (data?.token) {
      const expiryDays = 100;
      const expiresAt = Date.now() + expiryDays * 24 * 60 * 60 * 1000;

      const tokenObj = {
        token: data.token,
        expiresAt,
      };

      localStorage.setItem("authToken", JSON.stringify(tokenObj));
      // 🔥 Store raw token (extra)
      localStorage.setItem("token", data.token);
      
      console.log("📌 Token saved with expiry:", tokenObj);
    }

    // ⭐ STORE USER INFO
    if (data?.user?.id) {
      localStorage.setItem("userid", data.user.id);
      localStorage.setItem("useremail", data.user.email);
    }

    // 🔍 CHECK INCOMPLETE PROFILE
    if (data?.incomplete_profile === true) {
      Swal.fire({
        icon: "info",
        title: "Please complete your profile.",
        text: "Some required fields are missing.",
        showConfirmButton: true,
      });

      onClose();
      // navigate("/basic-info");   // 👈 using navigate
      window.location.href = "/basic-info";
      return;
    }

    // 🎉 SUCCESS LOGIN
    Swal.fire({
      icon: "success",
      title: "Login successful!",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });

    onLoginSuccess();
    onClose();
window.location.href = "/my-soulsathi";
    // navigate("/my-soulsathi");   // 👈 using navigate

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: error.response?.data?.error || "Invalid email or password!",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  } finally {
    setLoadingLogin(false);
  }
};


  // ------------------------------------------------------
  // ⭐ REGISTER FUNCTION WITH IP + DEVICE + LOCATION
  // ------------------------------------------------------
  const handleRegister = async (e) => {
  e.preventDefault();

  if (!name || !email || !password) {
    Swal.fire({
      icon: "warning",
      title: "Please fill all fields.",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2500,
    });
    return;
  }

  setLoadingRegister(true);

  try {
    const clientInfo = await getClientInfo();

    const registrationData = {
      name,
      email,
      password,
      login_type: "normal",
      ...clientInfo,
    };

    const response = await axios.post(`${baseurl}registerUser`, registrationData);

    if (response.data?.token) {
      localStorage.setItem("token", response.data.token);
    }

    if (response.data?.user?.id) {
      localStorage.setItem("userid", response.data.user.id);
      localStorage.setItem("useremail", response.data.user.email);
    }

    Swal.fire({
      icon: "success",
      title: response.data.message || "Registration successful!",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });

    setActiveTab("login");
    setName("");
    setEmail("");
    setPassword("");
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: error.response?.data?.error || "Registration failed!",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  } finally {
    setLoadingRegister(false);
  }
};



  const handleGoogleLogin = () => {
    alert("Google login coming soon...");
  };

  if (!show) return null;

  return (
    <>

    <PageCount pageName = {"Login-Signup Clicked"}/>
      {/* Backdrop */}
      <div className="login-modal-backdrop" onClick={onClose}></div>

      {/* Modal */}
      <div className="login-modal">
        <div className="login-modal-header d-flex justify-content-between align-items-center">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
            <span className="logo-text">Soulsathi.com </span>
          </Link>

          <button className="btn-close-modal" onClick={onClose}>
            <FiX size={22} />
          </button>
        </div>

        {/* Tabs */}
        <div className="login-tabs d-flex justify-content-around mb-3">
          <button
            className={`tab-btn ${activeTab === "login" ? "active" : ""}`}
            onClick={() => setActiveTab("login")}
          >
            Login
          </button>
          <button
            className={`tab-btn ${activeTab === "register" ? "active" : ""}`}
            onClick={() => setActiveTab("register")}
          >
            Register
          </button>
        </div>

        {/* Forms */}
        {activeTab === "login" ? (
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group mb-3">
              <label>Email</label>
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group mb-4">
              <label>Password</label>
              <div className="input-wrapper">
                <input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button
  type="submit"
  className="btn login-submit-btn w-100 mb-3"
  disabled={loadingLogin}
>
  {loadingLogin ? (
    <div className="spinner-border spinner-border-sm text-light"></div>
  ) : (
    "Login"
  )}
</button>

            <div className="or-divider">OR</div>

            <button
              type="button"
              className="btn google-btn w-100 mb-3"
              onClick={handleGoogleLogin}
            >
              <FcGoogle size={22} className="me-2" /> Continue with Google
            </button>

            <p className="terms-text mt-3">
              By proceeding, you agree to our{" "}
              <a href="/terms" target="_blank">Terms of Use</a>...
            </p>
          </form>
        ) : (
          <form className="login-form" onSubmit={handleRegister}>
            <div className="form-group mb-3">
              <label>Name</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Enter your full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group mb-3">
              <label>Email</label>
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group mb-4">
              <label>Password</label>
              <div className="input-wrapper">
                <input
                  type="password"
                  placeholder="Create a password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button
  type="submit"
  className="btn login-submit-btn w-100 mb-3"
  disabled={loadingRegister}
>
  {loadingRegister ? (
    <div className="spinner-border spinner-border-sm text-light"></div>
  ) : (
    "Register"
  )}
</button>


            <div className="or-divider">OR</div>

            <button
              type="button"
              className="btn google-btn w-100 mb-3"
              onClick={handleGoogleLogin}
            >
              <FcGoogle size={22} className="me-2" /> Continue with Google
            </button>

            <p className="terms-text mt-3">
              By proceeding, you agree to our{" "}
              <a href="/terms" target="_blank">Terms of Use</a>...
            </p>
          </form>
        )}
      </div>
    </>
  );
}

export default LoginModal;
